import React, { Component } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import Tabs from "./Tabs.js";
import Icon from "./Icon.js";
class Help extends Component {
    constructor (props) {
        super(props);
        this.state = {
        }
    }
    componentDidMount() {
    }
    render() {
        return (
            <>
                <div class="row align-items-center m-t-lg">
                    <div class="col-md-612 col-xs-12 p-lg-r-md">
                        <div class="card raised">
                            <div class="card-block p-a-sm bg-primary-light text-center text-inverse">
                                <h2 class="text-lg m-b-0">Help</h2>
                            </div>
                            <div class="card-block">
                            <h2>Frequently Asked Questions</h2>
<p><strong>What will I find in the ACG Education Universe?</strong></p>
<p>The ACG Education Universe contains material from ACG Annual Meetings, Postgraduate Courses, Abstracts, Journals, Self-Assessment Tests, additional material created specifically for the Education Universe, and more.</p>
<p><strong>How do I move around the Education Universe?</strong></p>
<p>There are tabs at the top of the page that help you to navigate your custom view of content you have saved and/or completed on the ACG Education Universe. </p>
<p><strong>Search Account Content</strong></p>
<p>There is a search box on the left side of the page that will allow you to search for topics or speakers in all of the content types. </p>
<p><strong>Home Tab</strong></p>
<p>Using the Home tab will bring you to the main page and will allow you to select the type of content you would like to view including Self-Assessment Tests, Courses, Modules, Journal CME, Podcasts, Presentations, and more. </p>
<p><strong>My Account Tab</strong></p>
<p>The My Account tab is where you will find all of the content you have interacted with while on the ACG Education Universe platform. If you have not started a content piece, there will be a red box allowing you to Remove that content piece. If you have interacted with a content piece, you will no longer be able to remove it from your My Account as this is the history of your interaction with the ACG Education Universe. </p>
<p><strong>Completed Tab</strong></p>
<p>The completed tab allows you to access all of the content you have completed in a single location. If you have completed content for CME, this is where you will go to access your CME certificates. Content that included CME will have a &ldquo;CME Certificate&rdquo; button which will generate a certificate that you can either download or print. Some content items also offer a &ldquo;Certificate of Completion&rdquo; which again can be downloaded or printed. If a content item did not include CME, there will be a &ldquo;Review&rdquo; button allowing you to access that piece of content again. </p>
<p><strong>All Content Tab</strong></p>
<p>The All Content tab will bring you to the main page and will allow you to select the type of content you would like to view including Self-Assessment Tests, Courses, Modules, Journal CME, Podcasts, Presentations, and more. </p>
<p><strong>About Tab</strong></p>
<p>The About tab includes information on accreditation, learning objectives, target audience, disclosure information, privacy policy, copyright policy, and technical requirements. </p>
<p><strong>Get Credits</strong></p>
<p>Starting in 2024, ACG members have the ability to claim any CME offered on the platform free of charge. Non-members will have access to a <a href="/getCredits"><strong>Get Credits</strong></a><strong> </strong>option on the left side of the page in the top box showing you name – this is where non-ACG members can purchase time to use on the available CME activities. </p>
<p><strong>Where is My Portfolio?</strong></p>
<p>My Portfolio has been renamed to My Account and is a repository of learned content that is accessible only to you. The My Account tab contains all of the activities you undertake in the ACG Education Universe.</p>
<p><strong>If I have questions or trouble using the Universe, who can I contact?</strong></p>
<p>Please email <a href="mailto:acguniverse@gi.org">acguniverse@gi.org</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Help;
